import {
  deleteCommonContact,
  deletePrivateContact,
  unassociateCommonContact,
} from "../../../../core/api/contacts/contacts";
import useTranslations from "../../../../core/i18n/useTranslations";
import useUser from "../../../../core/user/useUser";
import { notify } from "../../../../ui-lib/components/Alerts/Toast";
import PrimeModal from "../../../../ui-lib/components/PrimeModal/PrimeModal";
import { useState } from "react";
import { IContactsRelation } from "../../../../core/api/contacts/types";
import { notifyApiErrors } from "../../../../core/helpers/helpers";

const DeleteContactModal = ({
  isOpen,
  objectId,
  contact,
  onClose,
  onDelete,
}: {
  isOpen: boolean;
  objectId?: string;
  contact?: {
    id: number;
    userId?: number;
    associatedUsers?: IContactsRelation[];
  };
  onClose: () => void;
  onDelete: () => void;
}) => {
  const t = useTranslations();

  const { authenticatedRequest } = useUser();
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async () => {
    if (!contact) {
      return;
    }

    setSubmitting(true);
    try {
      if (objectId) {
        if (contact.userId) {
          await deletePrivateContact(
            objectId,
            contact.id,
            authenticatedRequest,
          );
        } else {
          await unassociateCommonContact(
            objectId,
            contact.id,
            authenticatedRequest,
          );
        }
      } else {
        await deleteCommonContact(contact.id, authenticatedRequest);
      }

      notify({
        message: t("Messages:delete_contact_success"),
      });
      onDelete();
    } catch (error: any) {
      notifyApiErrors(error.response?.data.errors);
    } finally {
      setSubmitting(false);
    }
  };

  const getConnectionMessage = (objectsLength?: number) => {
    if (objectsLength) {
      return `${t("Contacts:contact_associated_with")} ${objectsLength} ${
        objectsLength > 1 ? t("Objects:type_multi") : t("Objects:type")
      }`;
    }
    return null;
  };

  return (
    <PrimeModal
      withFooter
      withHeader
      header={t("Contacts:delete")}
      isOpen={isOpen}
      onClose={onClose}
      fixedWidth="576px"
      loading={submitting}
      submitBtn={{
        text: t("Contacts:delete"),
        variant: "destructive",
        onClick: onSubmit,
      }}
      cancelBtn={{ text: t("Common:cancel"), onClick: onClose }}
    >
      <div className="grey-600">
        {objectId ? (
          <p>{t("AlarmHistory:delete_object_contact_confirm")}</p>
        ) : (
          <>
            <p>{t("Messages:delete_contact_confirm")}</p>
            <p>{getConnectionMessage(contact?.associatedUsers?.length)}</p>
          </>
        )}
      </div>
    </PrimeModal>
  );
};

export default DeleteContactModal;
